export default "__VITE_ASSET__844d90c7__"